/**
 * Error and Warning Code Constants
 * Migrated from React application
 */

// Error Code Definitions (120-190)
export const ERROR_CODES = {
  120: 'Both Lamp off',
  130: 'LMS BUS ERROR',
  140: 'UZK too LOW',
  150: 'UZK too HIGH',
  160: 'EVG over temp',
  170: 'Power Supply failure',
  180: 'Lamps current overflow',
  190: 'Lamps current critical'
} as const;

// Warning Code Definitions (210-250)
export const WARNING_CODES = {
  210: 'UZK drop',
  220: 'Power supply low',
  230: 'Re-Ignition',
  240: 'Bad Lamp1',
  250: 'Bad Lamp2'
} as const;

// Color mappings for visualization
export const ERROR_COLOR_MAP: Record<number, string> = {
  120: '#ef4444', // red-500
  130: '#dc2626', // red-600
  140: '#b91c1c', // red-700
  150: '#991b1b', // red-800
  160: '#7f1d1d', // red-900
  170: '#dc2626', // red-600
  180: '#b91c1c', // red-700
  190: '#991b1b'  // red-800
};

export const WARNING_COLOR_MAP: Record<number, string> = {
  210: '#f59e0b', // amber-500
  220: '#d97706', // amber-600
  230: '#b45309', // amber-700
  240: '#92400e', // amber-800
  250: '#78350f'  // amber-900
};

// Threshold conditions for error detection
export interface ThresholdConfig {
  voltage: { min: number; max: number };
  current: { min: number; max: number };
  temperature: { max: number };
  uzk: { min: number; max: number };
}

export const THRESHOLDS: ThresholdConfig = {
  voltage: { min: 180, max: 260 },
  current: { min: 0, max: 50 },
  temperature: { max: 80 },
  uzk: { min: 200, max: 400 }
};

// Error code type
export type ErrorCode = keyof typeof ERROR_CODES;
export type WarningCode = keyof typeof WARNING_CODES;
export type Code = ErrorCode | WarningCode;
